export const TYPES = {
  UPDATE_INFO: 'UI_UPDATE_INFO',
  SET_INFO: 'UI_SET_INFO',
  SET_IS_SOCKET_CONNECTED: 'UI_SET_IS_SOCKET_CONNECTED',
  SET_BOTTOM_BAR_VISIBLE: 'UI_SET_BOTTOM_BAR_VISIBLE',
  SET_SURVEY_STATUS: 'UI_SET_SURVEY_STATUS',
  SET_SURVEY_DATA: 'UI_SET_SURVEY_DATA',
  CLEAR_SURVEY: 'UI_CLEAR_SURVEY',
  SET_SOCIAL_MEDIA_BANNER_STATUS: 'UI_SET_SOCIAL_MEDIA_BANNER_STATUS',
}
